import { getProduct } from '@commerce/api/operations'
import { Product, ProductMetafields } from '@commerce/types/product'
import { Price } from '@components/common'

import config from '@config/seo_meta.json'
import {
  PRODUCT_SHORT_DESCRIPTION,
  PRODUCT_SIMILAR_PRODUCTS,
  PRODUCT_TYPE_TOOLS,
} from '@lib/helpers/general'
import { useKeenSlider } from 'keen-slider/react'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

interface Props {
  context: any
  slice: any
}
const SimilarProducts = ({ slice, context }: Props) => {
  const { locale } = useRouter()
  const title = slice?.primary?.title
  const similarProductSlugs =
    context?.metafields?.filter(
      (metafield: ProductMetafields) =>
        metafield.key === PRODUCT_SIMILAR_PRODUCTS
    ).length > 0
      ? JSON.parse(
          context?.metafields?.filter(
            (metafield: ProductMetafields) =>
              metafield.key === PRODUCT_SIMILAR_PRODUCTS
          )[0].value
        )
      : []
  const [similarProducts, setSimilarProducts] = useState<Product[]>([])
  useEffect(() => {
    let products: Product[] = []
    const fetchSimilarColourProducts = async () => {
      const fetchProduct = similarProductSlugs?.map(
        async (v: string, index: number) => {
          await getProduct(locale, v, 'no-cache').then(
            (res) => (products[index] = res.product)
          )
        }
      )
      await Promise.all(fetchProduct)
      products = products.filter((product: Product) => {
        return product !== undefined
      })
      setSimilarProducts(products)
    }
    fetchSimilarColourProducts()
  }, [])
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    // initial: 0,
    loop: true,
    slides: {
      perView: 1.5,
      spacing: 24,
      origin: 'auto',
    },
    breakpoints: {
      '(min-width: 600px)': {
        slides: {
          perView: 2.4,
          spacing: 24,
          origin: 'auto',
        },
      },
      '(min-width: 1024px)': {
        slides: {
          perView: 4,
          origin: 'auto',
          spacing: 32,
        },
      },
    },
  })
  if (
    context?.productType !== PRODUCT_TYPE_TOOLS ||
    similarProducts.length == 0
  )
    return <></>

  return (
    <>
      <div className="wrapper w-full bg-brand-light-grey pb-8 lg:pb-20">
        <div>
          {title && (
            <div className="lg:heading-3 heading-mobile-3 pb-6 lg:pb-8">
              {title}
            </div>
          )}
          <div ref={sliderRef} className="keen-slider">
            {similarProducts &&
              similarProducts.map((product: Product) => {
                const productLink = product?.path
                const name = product?.name
                const shortDescription = product?.metafields?.filter(
                  (metafield: ProductMetafields) =>
                    metafield.key === PRODUCT_SHORT_DESCRIPTION
                )?.[0]?.value
                const image = product?.images?.[0]
                const price = product?.price
                return (
                  <Link
                    href={productLink || '/'}
                    passHref
                    key={product.id}
                    legacyBehavior
                  >
                    <div className="keen-slider__slide flex cursor-pointer flex-col gap-3">
                      <Image
                        alt={image.altText || config.openGraph.images[0].alt}
                        src={image.url}
                        layout="responsive"
                        width={251}
                        height={251}
                      />
                      <div className="flex flex-col gap-2">
                        {name && (
                          <div className="body-1 text-dark-grey">{name}</div>
                        )}
                        {shortDescription && (
                          <div className="body-2 text-dark-grey">
                            {shortDescription}
                          </div>
                        )}
                        {price && (
                          <Price
                            className="body-1-bold"
                            prefix={false}
                            price={price.value}
                            currencyCode={price.currencyCode}
                          ></Price>
                        )}
                      </div>
                    </div>
                  </Link>
                )
              })}
          </div>
        </div>
      </div>
    </>
  )
}

export default SimilarProducts
